<template>
  <span class="select-component">
    <select name="seller" class="mobileSellerId">
      <option value="">{{label}}</option>
      <option v-for="(value, key) in options" :key="key" :data-label="value.value" :id="'mobileSellerId-' + key" :selected="selectedSeller === value.id" :value="value.id">{{value.value}}</option>
    </select>
  </span>
</template>

<script>
export default {
name: "Seller",
  props: {
    label: {
      type: String
    },
    preselect: {
      type: String
    },
    options: {
      type: [Object, Array]
    }
  },
  data() {
    return {
      selectedSeller: parseInt(this.preselect, 10)
    }
  },

  mounted() {

  },
  methods: {
    selectSeller() {

      this.$emit("inputData", this.selectedSeller);

    }
  },
  beforeMount() {
    this.selectSeller(this.selectedSeller)
  }
}
</script>

<style scoped>

</style>